<template>
  <div
    class="flex justify-between fixed"
    style="z-index: 300"
    v-if="currentUser"
  >
    <div class="flex">
      <template v-for="item in filterMenuItems" :key="item.id">
        <app-header-menu-item
          :class="currentUrl == item.url ? 'active' : ''"
          :className="item.class"
          :iconName="item.iconName"
          :title="item.title"
          :subtitle="item.subtitle"
          @click="
            () => {
              activeMenuItemId = item.id
              $router.push(item.url)
            }
          "
        />
      </template>
    </div>
    <div>
      <div
        class="fixed rounded-l-full user-block flex items-end justify-end"
        :class="
          currentUser.role.is_office_worker === 0
            ? currentUser.denomination_type !== 1
              ? 'bg-rightMenuBlue'
              : ''
            : 'bg-headerGray'
        "
        :style="
          currentUser.denomination_type === 1 ? 'background-color:#86A4C6' : ''
        "
      >
        <div
          class="h-3/6 ml-8 flex flex-col content-center justify-center items-end"
        >
          <span class="text-white text-lg denomination-omit">{{
            currentUser.denomination_name
          }}</span>
          <span class="text-white text-lg font-bold">{{
            currentUser.name
          }}</span>
        </div>
        <div
          class="h-3/6 ml-3 flex flex-col content-center justify-center items-center"
        >
          <UserCircleIcn width="40" height="40" />
        </div>
        <div
          class="h-3/6 ml-3 mr-3 flex flex-col content-center justify-center items-center"
          v
        >
          <Menu as="div">
            <div>
              <MenuButton class="inline-flex justify-center">
                <ActionsIcn />
              </MenuButton>
            </div>

            <transition
              enter-active-class="transition duration-100 ease-out"
              enter-from-class="transform scale-95 opacity-0"
              enter-to-class="transform scale-100 opacity-100"
              leave-active-class="transition duration-75 ease-in"
              leave-from-class="transform scale-100 opacity-100"
              leave-to-class="transform scale-95 opacity-0"
            >
              <MenuItems
                class="absolute right-0 w-40 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-xl shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none border-4 border-solid border-blueSecondary"
              >
                <div class="px-1 py-1">
                  <MenuItem v-slot="{ active }">
                    <div class="flex flex-row items-center">
                      <button
                        :class="[
                          active ? '' : 'text-gray-900',
                          'group flex rounded-md items-center w-full px-2 py-2 text-sm',
                        ]"
                        @click="openProfileDialog()"
                      >
                        <UserCircleIcn
                          fill-rule="evenodd"
                          class="mr-1 lightblue-icon-user"
                          width="18"
                          height="18"
                        />
                        <span class="text-sm text-blueSecondary leading-none"
                          >プロフィール</span
                        >
                      </button>
                    </div>
                  </MenuItem>
                  <MenuItem v-slot="{ active }">
                    <div class="flex flex-row items-center">
                      <button
                        :class="[
                          active ? '' : 'text-gray-900',
                          'group flex rounded-md items-center w-full px-2 py-2 text-sm',
                        ]"
                        @click="logout()"
                      >
                        <LogoutIcn class="mr-1" width="21" height="16" />
                        <span class="text-sm text-blueSecondary leading-none"
                          >ログアウト</span
                        >
                      </button>
                    </div>
                  </MenuItem>
                </div>
              </MenuItems>
            </transition>
          </Menu>
        </div>
      </div>

      <div
        class="fixed rounded-l-full flex header-budget-block items-end justify-end"
        :class="
          currentUser.role.is_office_worker === 0
            ? currentUser.denomination_type !== 1
              ? 'bg-rightMenuBlue'
              : ''
            : 'bg-headerGray'
        "
        :style="
          currentUser.denomination_type === 1 ? 'background-color:#86A4C6' : ''
        "
      >
        <div
          v-if="
            currentUser.role.is_office_worker == 0 &&
              currentUser.role.rank === 1
          "
          class="flex flex-row justify-between items-center mr-4 w-full"
          style="height: 40px; margin-left: 40px;"
        >
          <div class="flex flex-row items-baseline">
            <span class="text-white text-lg font-bold">残</span>
            <span class="text-white text-xs font-bold">予算</span>
          </div>

          <div class="flex flex-row items-center">
            <MinusIcn class="mr-1" v-if="amount < 0" />
            <span class="text-white font-bold"
              >{{ Math.abs(amount ?? 0).toLocaleString() }}&nbsp;円</span
            >
          </div>
        </div>
        <div
          v-else
          class="flex flex-row justify-between items-center mr-4 w-full"
          style="height: 40px; margin-left: 40px;"
        >
          <div class="flex flex-row items-baseline">
            <span class="text-white text-lg font-bold">日付:</span>
            <span class="text-white text-lg font-bold">{{
              dayjs().format('YYYY年M月D日')
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <profile-dialog v-if="isOpen && type === 'profile'" />
</template>

<script>
import { useAuth } from '@/services/useAuth'
import { ref, reactive, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import AppHeaderMenuItem from '@/components/ui/AppHeaderMenuItem'
import ProfileDialog from '@/components/layout/user/ProfileDialog'
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import LogoutIcn from '@/assets/icons/logout.svg?inline'
import UserCircleIcn from '@/assets/icons/user-circle.svg?inline'
import ActionsIcn from '@/assets/icons/actions.svg?inline'
import MinusIcn from '@/assets/icons/minus.svg?inline'
import { useCurrentUser } from '@/services/useCurrentUser'
import { useDialog } from '@/services/useDialog'
import { useProfileDialog } from '@/services/user/useProfileDialog'
import { useBudgets } from '@/services/useBudgets'

export default {
  name: 'AppHeaderMenu',

  components: {
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    AppHeaderMenuItem,
    LogoutIcn,
    UserCircleIcn,
    MinusIcn,
    ActionsIcn,
    ProfileDialog,
  },

  setup() {
    const activeMenuItemId = ref(1)
    const { currentUser, getCurrentUser } = useCurrentUser()
    const { isOpen, type } = useDialog()
    const { getRemainingBudget, amount: amount } = useBudgets()
    const menuItems = reactive([
      {
        id: 1,
        title: 'ホーム',
        iconName: 'home',
        class: 'bg-blueSecondary',
        url: '/top',
        show: 'all',
      },
      {
        id: 2,
        class: 'bg-blue',
        title: '政務活動',
        iconName: 'lightning',
        url: '/activities',
        show: 'all',
      },
      {
        id: 3,
        class: 'bg-green',
        title: '領収書',
        iconName: 'receipt',
        url: '/receipts',
        show: 'all',
      },
      {
        id: 4,
        class: 'bg-yellow',
        title: '予算',
        iconName: 'money-circle',
        url: '/budgets',
        show: 'congressman-only',
      },
      {
        id: 5,
        class: 'bg-yellow opacity-50',
        title: '議員管理',
        iconName: 'user',
        url: '/',
        show: 'clerk-only',
      },
      {
        id: 6,
        class: 'bg-orange',
        title: '総括資料',
        iconName: 'timeline',
        url: '/logs',
        show: 'congressman-only',
      },
      {
        id: 7,
        class: 'bg-red-dark',
        title: 'お知らせ',
        iconName: 'notification',
        url: '/notifications',
        show: 'all',
      },
      {
        id: 8,
        class: 'bg-purple',
        title: '印刷',
        subtitle: 'データ',
        iconName: 'print',
        url: '/downloads',
        show: 'all',
      },
    ])

    onMounted(async () => {
      await getCurrentUser()
      await getRemainingBudget()
    })
    const filterMenuItems = computed(() => {
      if (currentUser.role.is_office_worker) {
        let afterItems = menuItems.filter(
          item => item.show === 'all' || item.show === 'clerk-only',
        )
        afterItems[0].class = 'bg-headerGray'
        return afterItems
      } else if (currentUser.denomination_type === 1) {
        let afterItems = menuItems.filter(
          item =>
            item.show === 'all' ||
            (item.show === 'congressman-only' &&
              item.iconName !== 'money-circle'),
        )
        afterItems[0].class = ''
        return afterItems
      } else {
        return menuItems.filter(
          item => item.show === 'all' || item.show === 'congressman-only',
        )
      }
    })

    const route = useRoute()
    const currentUrl = computed(() => route.path)

    return {
      activeMenuItemId,
      menuItems,
      currentUrl,
      currentUser,
      isOpen,
      type,
      ...useProfileDialog(),
      filterMenuItems,
      ...useAuth(),
      getRemainingBudget,
      amount,
    }
  },
}
</script>

<style lang="scss">
.download-btn {
  width: 150px;
  height: 80px;
  top: -40px;
  right: calc(270px - 14px);
}

.user-block {
  width: 304px;
  height: 144px;
  right: 0px;
  top: -72px;
  border-left: 2px solid white;
  border-bottom: 2px solid white;
  z-index: 10;
}

.header-budget-block {
  width: 242px;
  height: 80px;
  right: 0px;
  top: 32px;
  z-index: 8;
}

.denomination-omit {
  max-width: 174px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
